import { $ } from "@olmokit/dom";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import Dependency from "@olmokit/core/olmoforms/dependency";
import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/textarea/filled";
import axios from "axios";
import { globalConf } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";
import "./index.scss";

/** reCAPTCHA v3 site key — same key loaded globally in layouts/main. */
const RECAPTCHA_SITE_KEY = "6LfzBrYrAAAAAPZEBP-w_GyN9AcH18mZA2w6i4NO";

declare const grecaptcha: {
  execute(siteKey: string, options: { action: string }): Promise<string>;
};

/**
 * Component: FormNewsletter
*
*/
export function FormNewsletter() {

  const olmoform = Olmoforms(".FormNewsletter:", {
    /**
     * Bot protection: get a reCAPTCHA v3 token and have it verified server-side
     * before the form is allowed through. Olmoforms awaits this hook, so calling
     * `boot()` (sets bootCheck) and/or rejecting aborts the submission.
     * Mirrors Form/Contacts/Private.ts.
     */
    before: async () => {
      // Honeypot: hidden field real users never fill, bots do (olmoforms form 10).
      const $localcheck = $("#of-10-localcheck") as HTMLInputElement;
      if ($localcheck.value !== "") {
        olmoform.boot(); // prevents the submit
        return Promise.reject("Local check failed");
      }

      try {
        const { data: ip } = await post("detectip", {
          data: { item: "$minimal" },
        });

        const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, {
          action: "submit",
        });

        await axios.post(globalConf.cmsApiUrl + "/recaptcha", { token, ip });
      } catch (error) {
        console.error("Newsletter: reCAPTCHA verification failed", error);
        olmoform.boot(); // prevents the submit
        return Promise.reject("Hook before failed");
      }
    },
    sent: (response) => {
      const { formData } = response;
      dataLayer.push({
        ...formData,
        event: "form sent",
        form: "Newsletter Form",
      });
    },
  });

  FormsInputMaterial();
  FormsSelectMaterial();
  Dependency(".FormNewsletter:");

  return {
    destroy() {
      olmoform.destroy();
    },
  };

}
